document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth <= 749) {
    // Only target headings within footer links, not newsletter
    const footerHeadings = document.querySelectorAll('.footer__links .footer-block__heading');
    
    footerHeadings.forEach(heading => {
      heading.addEventListener('click', function() {
        const content = this.nextElementSibling;
        
        // Toggle active class
        this.classList.toggle('active');
        content.classList.toggle('active');
      });
    });
  }
});
